'use client';

import { cls } from '../libs/utils/class-utils';
import { fontFox2027, rubik } from '../libs/constants/fonts';
import { Network } from '../components/layouts/main-layout/network';
import styles from 'components/layouts/main-layout/main-layout.module.scss';
import stylesHeader from 'components/layouts/main-layout/header/header.module.scss';
import stylesNav from 'components/layouts/main-layout/header/nav/nav.module.scss';
import { SocialNetworksLayout } from '../components/layouts/main-layout/social-networks-layout';
import { Footer } from '../components/layouts/main-layout/footer';
import LogoSvg from '../components/ui/icons/logoSVG';
import { listNav } from '../libs/constants/nav';
import Link from 'next/link';
import { Search } from '../components/layouts/main-layout/header/search';
import { useState } from 'react';
import { liveBroadcast } from '../libs/constants/live-broadcast';
import { ErrorPageComponents } from '../components/error-page-component/ErrorPageComponents';

interface IProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: IProps) {
  const [openMenu, setOpenMenu] = useState(false);
  const [hiddenInput, setHiddenInput] = useState(false);
  const [live] = liveBroadcast;

  const onClickBurger = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <html lang="ru" className={cls('', {}, [rubik.variable, fontFox2027.variable])}>
      <body>
        <Network /> {/* Компонент  контейнер ссылок на все проекты Звезды*/}
        <section className={styles.wrapper}>
          <header className={stylesHeader.header}>
            <LogoSvg className={stylesHeader.logoSVG} />
            <nav className={cls(stylesNav.nav, { [stylesNav.active]: openMenu })}>
              {listNav.map(({ link, title }) => (
                <Link
                  className={stylesNav.link}
                  key={title}
                  href={link}
                  onClick={onClickBurger}
                >
                  {title}
                </Link>
              ))}
              <li className={cls('', {}, [stylesNav.link, stylesNav.mobileButtonMenu])}>
                <Search
                  onClickBurger={onClickBurger}
                  hiddenInput={hiddenInput}
                  setHiddenInput={setHiddenInput}
                />
              </li>
            </nav>
            <button
              className={`${stylesNav.burger} ${openMenu ? stylesNav.active : ''}`}
              onClick={onClickBurger}
            ></button>
            <section className={stylesHeader.rest}>
              <Search hiddenInput={hiddenInput} setHiddenInput={setHiddenInput} />{' '}
              {/* Поиск */}
            </section>
          </header>
          <main className={styles.container}>
            <ErrorPageComponents error={error} reset={reset} />
            <aside className={styles.line} />
          </main>
          <SocialNetworksLayout /> {/* ссылки на соц сети */}
          <Footer /> {/* футтер */}
        </section>
      </body>
    </html>
  );
}
